var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { EnrollmentStatus } from '@/components/organisms';
import { MyCoursesList } from './templates/MyCoursesList/MyCoursesList';
import * as Styled from './MyCourses.style';
const MOCK_TABS = [
    { label: 'Meus cursos', value: 'my-courses' },
];
const MOCK_FILTERS = [
    {
        id: 'status',
        label: 'Situação de Progresso',
        options: [
            { id: 'not_started', label: 'Não iniciado', value: 'not_started', checked: false },
            { id: 'in_progress', label: 'Em andamento', value: 'in_progress', checked: true },
            { id: 'completed', label: 'Concluído', value: 'completed', checked: false },
            { id: 'not_completed', label: 'Não concluído', value: 'expired', checked: false },
            { id: 'approved', label: 'Aprovado', value: 'approved', checked: false },
            { id: 'not_approved', label: 'Reprovado', value: 'not_approved', checked: false },
            { id: 'abandon', label: 'Abandono', value: 'abandon', checked: false },
        ],
    },
    {
        id: 'type',
        label: 'Situação de matrícula',
        options: [
            { id: 'canceled', label: 'Cancelado', value: 'canceled', checked: false },
            { id: 'dropout', label: 'Desistente', value: 'dropout', checked: false },
            { id: 'enrolled', label: 'Matriculado', value: 'enrolled', checked: false },
        ],
    },
];
const MOCK_CARDS = [
    {
        imageSrc: 'https://ava.sebrae.com.br/App/Api/Training/Training/GetTrailImageBase64?idTraining=5318',
        tag: 'Empreendedorismo',
        type: 'Curso | ',
        title: 'Imersão Empreendedora Sebrae',
        description: 'Lorem ipsum dolor sit amet consectetur. Urna auctor dui dictum non nam. Quam a sed urna morbi in cras viverra.',
        status: EnrollmentStatus.IN_PROGRESS,
        enrollmentDate: new Date('2025-12-08'),
        deadlineDate: new Date('2025-12-28'),
        progress: 20,
        buttonText: 'Acessar',
    },
    {
        imageSrc: 'https://ava.sebrae.com.br/App/Api/Training/Training/GetActivityImageBase64?idTraining=3487&typeTraining=OnlineCourse',
        tag: 'Desenvolvimento Local',
        type: 'Curso | ',
        title: 'Comece a empreender na comunidade',
        description: 'Lorem ipsum dolor sit amet consectetur. Urna auctor dui dictum non nam. Quam a sed urna morbi in cras viverra.',
        status: EnrollmentStatus.COMPLETED,
        enrollmentDate: new Date('2025-07-30'),
        deadlineDate: new Date('2025-08-14'),
        progress: 100,
        buttonText: 'Acessar',
    },
    {
        imageSrc: 'https://ava.sebrae.com.br/App/Api/Training/Training/GetActivityImageBase64?idTraining=2878&typeTraining=OnlineCourse',
        tag: 'Empreendedorismo',
        type: 'Curso | ',
        title: 'Marketing de Conteúdo',
        description: 'Lorem ipsum dolor sit amet consectetur. Urna auctor dui dictum non nam. Quam a sed urna morbi in cras viverra.',
        status: EnrollmentStatus.COMPLETED,
        enrollmentDate: new Date('2025-07-03'),
        deadlineDate: new Date('2025-07-13'),
        progress: 100,
        buttonText: 'Acessar',
    },
    {
        imageSrc: 'https://ava.sebrae.com.br/App/Api/Training/Training/GetActivityImageBase64?idTraining=3538&typeTraining=OnlineCourse',
        tag: 'Empreendedorismo',
        type: 'Curso | ',
        title: 'Design Thinking',
        description: 'Lorem ipsum dolor sit amet consectetur. Urna auctor dui dictum non nam. Quam a sed urna morbi in cras viverra.',
        status: EnrollmentStatus.COMPLETED,
        enrollmentDate: new Date('2025-06-23'),
        deadlineDate: new Date('2025-07-23'),
        progress: 100,
        buttonText: 'Acessar',
    },
];
const BASE_URL = "https://lmsapirest.eadtech.net";
const PASSPORT = '2073e30994544b9187f182de9cb404ae';
const API_KEY = '6b15293ce129cca5ff616a6d75c40c43';
// --- COMPONENTE DE PÁGINA ---
export const MyCoursesPage = () => {
    // Estados para controlar o componente
    const [selectedTab, setSelectedTab] = useState('my-courses');
    const [filters, setFilters] = useState(MOCK_FILTERS);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const itemsPerPage = 10;
    const [enrollments, setEnrollments] = useState([]);
    const [loadingTrainings, setLoadingTrainings] = useState(true);
    const [finalCards, setFinalCards] = useState(MOCK_CARDS);
    const getCourse = (solutionId) => __awaiter(void 0, void 0, void 0, function* () {
        const courseResponse = yield fetch(`${BASE_URL}/course/${solutionId}`, {
            method: 'GET',
            headers: {
                'ApiKeyAuth': API_KEY,
                'Passport': PASSPORT,
            },
        });
        const data = yield courseResponse.json();
        return data;
    });
    const getTrail = (solutionId) => __awaiter(void 0, void 0, void 0, function* () {
        const trailResponse = yield fetch(`${BASE_URL}/trail/${solutionId}`, {
            method: 'GET',
            headers: {
                'ApiKeyAuth': API_KEY,
                'Passport': PASSPORT,
            },
        });
        const data = yield trailResponse.json();
        return data;
    });
    useEffect(() => {
        // const fetchEnrollments = async () => {
        // try {
        // const enrollmentResponse = await fetch(
        // `${BASE_URL}/enrollment/byCPF/69442932187?page=${currentPage}&pageSize=${itemsPerPage}&order=enrollmentDate&direction=desc`, 
        // {
        // method: 'GET',
        // headers: {
        // 'ApiKeyAuth': API_KEY,
        // 'Passport': PASSPORT,
        // },
        // });
        // const data = await enrollmentResponse.json() as EnrollmentsResponse;
        // setEnrollments(data.returnedList);
        // setTotalItems(data.paginationInfo.totalSize)
        // } catch (error) {
        // console.error('Erro ao buscar matrículas:', error);
        // }
        // };
        // fetchEnrollments();
    }, [currentPage, itemsPerPage]);
    useEffect(() => {
        const fetchCourseDetails = () => __awaiter(void 0, void 0, void 0, function* () {
            if (enrollments.length === 0)
                return;
            setLoadingTrainings(true);
            try {
                const promises = enrollments.map((enrollment) => __awaiter(void 0, void 0, void 0, function* () {
                    var _a;
                    if (enrollment.type === 'Course' || enrollment.type === 'Trail') {
                        try {
                            const training = enrollment.type === 'Course'
                                ? yield getCourse(enrollment.solutionId)
                                : yield getTrail(enrollment.solutionId);
                            // Mapeia para o formato EnrollmentCardProps
                            const statusMap = {
                                'Registered': EnrollmentStatus.IN_PROGRESS,
                                'Approved': EnrollmentStatus.COMPLETED,
                                'Completed': EnrollmentStatus.COMPLETED,
                            };
                            return {
                                id: enrollment.solutionId.toString(),
                                imageSrc: training.imgLink || (enrollment.type === 'Trail'
                                    ? `https://ava.sebrae.com.br/App/Api/Training/Training/GetTrailImageBase64?idTraining=${enrollment.solutionId}`
                                    : `https://ava.sebrae.com.br/App/Api/Training/Training/GetActivityImageBase64?idTraining=${enrollment.solutionId}&typeTraining=OnlineCourse`),
                                tag: ((_a = training.category) === null || _a === void 0 ? void 0 : _a.name) || (enrollment.type === 'Trail' ? 'Trilha' : 'Curso'),
                                type: enrollment.type === 'Trail' ? 'Trilha | ' : 'Curso | ',
                                title: training.name,
                                description: training.description || '',
                                status: statusMap[enrollment.status] || EnrollmentStatus.IN_PROGRESS,
                                enrollmentDate: new Date(enrollment.enrollmentDate),
                                deadlineDate: String(enrollment.deadlineDate).split(" ")[0],
                                progress: enrollment.progressPercent,
                                buttonText: 'Acessar',
                                courseWorkload: training.hours ? `${training.hours}h` : undefined,
                            };
                        }
                        catch (err) {
                            console.error(`Erro ao buscar ${enrollment.type === 'Trail' ? 'trilha' : 'curso'} ${enrollment.solutionId}:`, err);
                            return null;
                        }
                    }
                    return null;
                }));
                const results = yield Promise.all(promises);
                // console.log(results)
                const validCards = results.filter((card) => card !== null);
                setFinalCards(validCards);
            }
            catch (error) {
                console.error('Erro ao processar cursos:', error);
            }
            finally {
                setLoadingTrainings(false);
            }
        });
        fetchCourseDetails();
    }, [enrollments]);
    // Handlers (Funções de Callback)
    const handlePageChange = (page) => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        setCurrentPage(page);
    };
    const handleTabChange = (tabValue) => {
        console.log('Aba alterada para:', tabValue);
        setSelectedTab(tabValue);
    };
    const handleFilterChange = (sectionId, value, checked) => {
        console.log('Filtro alterado:', { sectionId, value, checked });
        setFilters(prevFilters => prevFilters.map(section => {
            if (section.id === sectionId) {
                return Object.assign(Object.assign({}, section), { options: section.options.map(opt => opt.value === value ? Object.assign(Object.assign({}, opt), { checked }) : opt) });
            }
            return section;
        }));
    };
    const handleRemoveFilter = (sectionId, value) => {
        console.log('Removendo filtro:', { sectionId, value });
        handleFilterChange(sectionId, value, false);
    };
    const handleClearFilters = () => {
        console.log('Limpando todos os filtros');
        setFilters(prevFilters => prevFilters.map(section => (Object.assign(Object.assign({}, section), { options: section.options.map(opt => (Object.assign(Object.assign({}, opt), { checked: false }))) }))));
    };
    // Simulação de filtragem de dados baseada no estado
    // const filteredCards = MOCK_CARDS.filter(card => {
    //   // Exemplo simples: se aba for 'completed', mostra só cards com 100% de progresso
    //   if (selectedTab === 'completed' && card.progress < 100) return false;
    //   if (selectedTab === 'in_progress' && (card.progress === 100 || card.progress === 0)) return false;
    //   return true;
    // });
    // Paginação dos dados
    // const paginatedCards = filteredCards.slice(
    //   (currentPage - 1) * itemsPerPage,
    //   currentPage * itemsPerPage
    // );
    return (_jsx(Styled.Fragment, { children: _jsx(MyCoursesList
        // Dados
        , { 
            // Dados
            tabs: MOCK_TABS, filterSections: filters, enrollmentCards: MOCK_CARDS, 
            // Estado
            selectedTab: selectedTab, currentPage: currentPage, totalItems: totalItems, itemsPerPage: itemsPerPage, isTrainningsLoading: loadingTrainings, 
            // Callbacks
            onPageChange: handlePageChange, onTabChange: handleTabChange, onFilterChange: handleFilterChange, onRemoveFilter: handleRemoveFilter, onClearFilters: handleClearFilters }) }));
};
//# sourceMappingURL=MyCourses.js.map